import React, { Component } from 'react';
import  SearchForm  from "../../util/searchform/SearchForm";
import  TableTemplate  from "../../util/tabletemplate/TableTemplate";
import  NoItems  from "../../util/noitems/NoItems";
import Modal from '../../util/modal/Modal';
import AcceptModal from '../../util/acceptModal/AcceptModal';
import FlavorForm from './FlavorForm';
import Pagination from '../../util/pagination/Pagination';
import FlavorsAPI from '../../../services/Flavor';
import { toast } from 'react-toastify';
import Loading from '../../util/loading/Loading';
import Validators from '../../../util/validators';

import ModoGuiado from "../../modoGuiado/ModoGuiado"
import BtnModoGuiado from '../../util/BtnModoGuiado/BtnModoGuiado'
import ErrorMessages from '../../../util/validation-error-messages';
import lodash from 'lodash';
import roles from '../../../util/strings/roles';

class Flavors extends Component {
    flavors = [];

    constructor(props){
        super(props);
        this.state = {
            flavors: [],
            pageFlavors: [],
            filterText: "",
            flavor: null,
            showModal: false,
            editing: false,
            removeModal: false,
            isLoading: false
        }
    }

    componentWillMount(){
        this.setState({isLoading: true})
        FlavorsAPI.getAll().then(response => {
            
            this.setState({flavors: response.data, isLoading: false});
            this.flavors = response.data;
        }).catch(err => {
            this.setState({isLoading: false})
            if(err.response)
                toast.error(err.response.data.Message)
            else
                toast.error(ErrorMessages.SinConexion)
        })
    }

    // Método encargado de recibir el texto en el input de búsqueda y filtrar los elementos en
    // la tabla 
    handleSearchInput = (text) => {
        let flavors = this.flavors.filter(flavor => flavor.Name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(text.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")));
        let state = this.state;
        state.filterText = text;
        state.flavors = flavors;
        this.setState(state);
    }

    /**Redirige a vista de formulario para crear nuevo tipo sabor */
    create = () => {
        this.props.history.push({pathname:'/sabores/nuevo', state:{flavors: this.flavors}});
    }

    edit = (flavor) => {
        
        this.setState({isLoading: true}, () => {
            FlavorsAPI.edit(flavor).then(response => {
                let state = {...this.state};
                state.flavors[state.flavors.findIndex(c => c.FlavorTypeId === flavor.FlavorTypeId)] = response.data;
                state.pageFlavors[state.pageFlavors.findIndex(c => c.FlavorTypeId === flavor.FlavorTypeId)] = response.data;
                this.flavors[this.flavors.findIndex(c => c.FlavorTypeId === flavor.FlavorTypeId)] = response.data;
                state.isLoading = false;
                state.showModal = false;
                state.flavor = null;
    
                this.setState(state, () => toast.success("Sabor actualizado"));
            }).catch(err => {
                this.setState({isLoading: false});
                if(err.response)
                    toast.error(err.response.data.Message);
                else
                    toast.error(ErrorMessages.SinConexion);
            })
        });
    }

    remove = () => {
        this.setState({isLoading: true});
        FlavorsAPI.delete(this.state.flavor.FlavorTypeId).then(response => {
            let state = {...this.state};

            state.flavors.splice(state.flavors.findIndex(c => c.FlavorTypeId === state.flavor.FlavorTypeId), 1);
            state.pageFlavors.splice(state.pageFlavors.findIndex(c => c.FlavorTypeId === state.flavor.FlavorTypeId), 1);
            this.flavors.splice(this.flavors.findIndex(c => c.FlavorTypeId === state.flavor.FlavorTypeId), 1);
            state.isLoading = false;
            state.removeModal = false;
            state.flavor = null;
            toast.success("Sabor eliminado");
            this.setState(state);
        }).catch(err => {
            this.setState({isLoading: false, flavor: null, removeModal: false});
            if(err.response)
                toast.error(err.response.data.Message)
            else
                toast.error(ErrorMessages.SinConexion)
        })
    }

    render() {
        return (
            <div>

                <ModoGuiado 
                    ruta="sabores"
                    tipoModoGuiado="receta"
                    anterior="tipos-receta"
                    siguiente='granos' 
                    mensaje="Sabor al que pertenece un producto terminado" />

                <h1 className="title is-2">Tipo de sabor</h1>
                <div className="columns is-vcentered">
                    <div className="column is-5">
                        <div className="card">
                            <div className="card-content">
                                <div className="field">
                                    <div className="control">
                                        <SearchForm
                                            filterText={this.state.filterText}
                                            onInput={(t) => this.handleSearchInput(t)}
                                            itemName={'Sabor'}
                                            placeholderText = {"Ingrese nombre de tipo sabor."}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="column is-7">
                        <div className="field">
                            <div className="control has-text-right">
                                {lodash.intersection(localStorage.getItem('role').split(","), [roles.ADMIN, roles.ADMINDRIVE, roles.ESPECIALISTA_DE_PRODUCTO, roles.COORDINADOR_GESTION_OPERACIONES]).length > 0 &&
                                    <a id="btnAddFlavor" className="button is-success" onClick={(e) => this.create()}>
                                        <span className="icon is-small">
                                            <i className="fa fa-plus"></i>
                                        </span>
                                        <span>Agregar Sabor</span>
                                    </a>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="card">
                    <div className="card-content">
                        {this.state.flavors.length !== 0 
                        ? <TableTemplate
                            columns={["FlavorTypeId","Name","ShortName","Position", "NombreSegmento"]}
                            columnsNames={["ID", "Nombre", "Nombre Corto", "Posición en Menú", "Segmento"]}
                            data={this.state.pageFlavors}
                            rowClickable={true}
                            details={(flavor) => this.setState({showModal: true, flavor: flavor})}
                            canEdit canDelete 
                            edit={(flavor) => this.setState({showModal: true, flavor: flavor})} 
                            remove={(flavor) => this.setState({removeModal: true, flavor: flavor})}
                        /> 
                        : <NoItems itemName="sabores"/>}
                        <Pagination items={this.state.flavors} onChangePage={(flavors) => this.setState({ pageFlavors: flavors })} />
                    </div>
                </div>
                {this.state.showModal && 
                    <Modal
                        showModal={this.state.showModal}
                        modalTitle={"Editar Sabor"}
                        cancel={() => this.setState({showModal: false, unit: null})}
                    >
                        <FlavorForm
                            flavor={this.state.flavor}
                            save={this.edit}
                            flavors={this.flavors}
                            isEditing={true}
                        />   
                    </Modal>
                }
                {this.state.removeModal && <AcceptModal
                    isActive={this.state.removeModal}
                    done={() => this.remove()}
                    cancel={() => this.setState({removeModal: false})}
                    modalTitle={"Eliminar Sabor"}
                />}
                <Loading isFullscreen={true} isLoading={this.state.isLoading} width='100px' height='100px'/>

                <BtnModoGuiado />                

            </div>
        );
    }
}

export default Flavors;
